import { LayerManager } from 'models';
import WmsTileLayer from './WMSTileLayer';
import { WriteTransactionOptions } from 'ol/format/WFS';
import { MAP_PROJECTION } from 'config';

/**
 * The WMSEditableLayer is a specially styled WmsTileLayer,
 * intended to display WMS layers with editable capabilities
 */
export class WMSEditableLayer extends WmsTileLayer {
    public readonly transactionOptions: WriteTransactionOptions;

    constructor(config: LayerManager.LayerConfig) {
        super({
            config,
        });
        const [featurePrefix, featureType] = config.serviceName?.split(':') ?? [
            '',
            '',
        ];

        this.transactionOptions = {
            featureNS: config.featureNS
                ? config.featureNS
                : 'http://cfs.sa.gov.au/risk-planning',
            featurePrefix,
            featureType,
            nativeElements: [],
            version: '1.1.0',
            srsName: config.srsName ? config.srsName : MAP_PROJECTION.getCode(),
        };
    }

    getURL() {
        return this.url;
    }
}

export default WMSEditableLayer;
